export default "__VITE_ASSET__0ce3adcd__"